module.exports = __webpack_public_path__ + "img/tu2.98bcbba9.jpg";